import { makeStyles } from '@material-ui/styles';
import UserIcon, { IconSizes } from '../UserIcon';
import UserAvatarUploader from './UserAvatarUploader';

export type UserIconWithUpload = {
    photoUrl: string;
    size?: IconSizes;
    value?: string;
    onChange?: (url: string) => void;
    config;
};

const UserIconWithUpload: React.FC<UserIconWithUpload> = ({
    photoUrl,
    size = 'XX-Large',
    value,
    onChange,
    config,
}) => {
    const classes = useStyles();

    return (
        <div className={classes.iconWrapper}>
            <UserIcon photoUrl={value || photoUrl} size={size} />
            <div className={classes.uploaderContainer}>
                <UserAvatarUploader onChange={onChange} config={config} />
            </div>
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        iconWrapper: {
            position: 'relative',
            display: 'inline-block',
        },
        uploaderContainer: {
            width: '2.4rem',
            height: '2.4rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            top: 0,
            right: 0,
            borderRadius: '50%',
            backgroundColor: theme.palette.greys[700],
            [theme.breakpoints.down('sm')]: {
                width: 20,
                height: 20,
            },
        },
    }),
    { classNamePrefix: 'user-icon' }
);

export default UserIconWithUpload;
